var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplayDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1255 15.6253C18.1255 15.7911 18.0596 15.9501 17.9424 16.0673C17.8252 16.1845 17.6663 16.2503 17.5005 16.2503C17.3347 16.2503 17.1758 16.1845 17.0586 16.0673C16.9413 15.9501 16.8755 15.7911 16.8755 15.6253C16.8734 13.8026 16.1484 12.0551 14.8596 10.7663C13.5707 9.47741 11.8232 8.75241 10.0005 8.75035H4.00909L6.69268 11.4332C6.80996 11.5504 6.87584 11.7095 6.87584 11.8753C6.87584 12.0412 6.80996 12.2003 6.69268 12.3175C6.5754 12.4348 6.41634 12.5007 6.25049 12.5007C6.08464 12.5007 5.92558 12.4348 5.8083 12.3175L2.0583 8.56753C2.00019 8.50949 1.95409 8.44056 1.92264 8.36468C1.89119 8.28881 1.875 8.20748 1.875 8.12535C1.875 8.04321 1.89119 7.96188 1.92264 7.88601C1.95409 7.81014 2.00019 7.7412 2.0583 7.68316L5.8083 3.93316C5.92558 3.81588 6.08464 3.75 6.25049 3.75C6.41634 3.75 6.5754 3.81588 6.69268 3.93316C6.80996 4.05044 6.87584 4.20949 6.87584 4.37535C6.87584 4.5412 6.80996 4.70026 6.69268 4.81753L4.00909 7.50035H10.0005C12.1547 7.50262 14.22 8.35938 15.7432 9.88262C17.2665 11.4059 18.1232 13.4712 18.1255 15.6253Z",
    fill: "#616E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayDark);
export default __webpack_public_path__ + "static/media/ReplayDark.571fa8eda1639990109119c6af277035.svg";
export { ForwardRef as ReactComponent };